/** Set before in-app navigation reloads so beforeunload must not stop renderers (#1514). */
export const SUPPRESS_TRANSPORT_TEARDOWN_KEY = 'maestro_suppress_transport_teardown';

export function markInAppNavigationReloadPending(): void {
  try {
    sessionStorage.setItem(SUPPRESS_TRANSPORT_TEARDOWN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function shouldSuppressTransportTeardownOnPageHide(event?: PageTransitionEvent): boolean {
  try {
    if (sessionStorage.getItem(SUPPRESS_TRANSPORT_TEARDOWN_KEY) === '1') return true;
  } catch {
    /* ignore */
  }
  if (event?.persisted) return true;
  return false;
}

export function clearInAppNavigationReloadPending(): void {
  try {
    sessionStorage.removeItem(SUPPRESS_TRANSPORT_TEARDOWN_KEY);
  } catch {
    /* ignore */
  }
}
